enum Variant {
    PRIMARY = 'primary',
    SECONDARY = 'secondary',
    SECONDARY_TEXT = 'secondary-text',
    LIGHT = 'light',
    LIGHT_ON_PRIMARY = 'light-on-primary',
    WHITE = 'white',
    WHITE_PRIMARY_HOVER = 'white-primary-hover',
    WHITE_ON_SURFACE = 'white-on-surface',
    DARK = 'dark',
    RED = 'red',
    GRAY = 'gray',
    BLUE = 'blue',
    DARK_GRAY = 'dark-gray',
    LIGHT_CONTRAST = 'light-contrast',
    TRANSPARENT = 'transparent',
    BORDERED = 'bordered',
    LINK = 'link',
}

const variants: string[] = Object.values(Variant);
const validator = (value: string): boolean => variants.includes(value);

export { Variant, validator };
